import React, { useContext, useState } from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import CommonContext from "../../store/Common";
import useSiteCompanyInfo from "../../hooks/useSiteCompanyInfo";

function Footer() {
  const { isMobile } = useContext(CommonContext);
  const [show, setShow] = useState(false);
  const info = useSiteCompanyInfo();

  if (isMobile) return null;

  return (
    <footer>
      <div className="wrap_footer pc">
        <div className="info">
          <p className="company_name">{info.company_name}</p>
          <p>
            법인등록번호: {info.corporate_reg_no} / 대표이사: {info.ceo_name}
          </p>
          <p>사업자등록번호: {info.business_reg_no}</p>
          <br />
          <p>본사: {info.hq_address}</p>
          <p>지사: {info.branch_address}</p>
          <p>베트남: {info.vietnam_address}</p>
          <p>
            대표전화: {info.phone} | 팩스: {info.fax}
          </p>
          <p>이메일: {info.email}</p>
          <p>{info.copyright}</p>
        </div>
        <div>
          <ul className="links">
            <li>
              <Link to="/intro/service/detail">기능소개</Link>
            </li>
            <li>
              <Link to="/intro/price">이용가격</Link>
            </li>
            <li>
              <Link to="/intro/service">고객문의</Link>
            </li>
          </ul>
          <div className="list_link">
            <a href="https://www.facebook.com/biznavi.co.kr" target="_blank">
              <img
                src={
                  require("../../assets/images/footer/icon-facebook-link.svg")
                    .default
                }
                alt="이미지"
              />
            </a>
            <a
              href="https://www.instagram.com/biznavi__official"
              target="_blank"
            >
              <img
                src={
                  require("../../assets/images/footer/icon-instagram-link.svg")
                    .default
                }
                alt="이미지"
              />
            </a>
            <a href="https://blog.naver.com/findbiz_official" target="_blank">
              <img
                src={
                  require("../../assets/images/footer/icon-blog-link.svg")
                    .default
                }
                alt="이미지"
              />
            </a>
            <a href="https://media.findbiz.co.kr/" target="_blank">
              <img
                src={
                  require("../../assets/images/footer/icon-media-link.svg")
                    .default
                }
                alt="이미지"
              />
            </a>
          </div>
        </div>
        <p className="terms_link">
          <Link to="/terms/use">서비스 이용약관</Link>
          <span>|</span>
          <Link to="/terms/private">개인정보 처리방침</Link>
        </p>
      </div>
      <div className="wrap_footer mo">
        <button className="btn_toggle" onClick={() => setShow(!show)}>
          <span>{show ? "접기" : "펼치기"}</span>
          <i
            className={`${
              show ? "icon_more_arrow_up_white" : "icon_more_white"
            }`}
          />
        </button>
        <div className="contact">
          <p className="title">IPNOW에게 문의하기</p>
          <div>
            <i className="icon_m_call" />
            <p>{info.phone}</p>
          </div>
          <div>
            <i className="icon_m_fax" />
            <p>{info.fax}</p>
          </div>
          <div>
            <i className="icon_m_mail" />
            <p>{info.email}</p>
          </div>
        </div>
        {show && (
          <>
            <p className="line" />

            <div className="info">
              <p>법인명(단체명): {info.company_name}</p>
              <p>대표이사: {info.ceo_name}</p>
              <p>법인등록번호: {info.corporate_reg_no}</p>
              <p>사업자등록번호: {info.business_reg_no}</p>
              <p>본사: {info.hq_address}</p>
              <p>지사: {info.branch_address}</p>
              <p>베트남: {info.vietnam_address}</p>
            </div>

            <p className="line" />

            <ul className="links">
              <li>
                <Link to="/intro/service/detail">기능소개</Link>
              </li>
              {/*<li>*/}
              {/*  <Link to="/intro/price">이용가격</Link>*/}
              {/*</li>*/}
              <li>
                <Link to="/intro/service">고객문의</Link>
              </li>
              <li>
                <Link to="/terms/use">서비스 이용약관</Link>
              </li>
              <li>
                <Link to="/terms/private">개인정보 처리방침</Link>
              </li>
            </ul>
          </>
        )}

        <p className="copyright">
          {info.copyright}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
